import { FC } from 'react'

import styles from '~/shared/styles/Input.module.css'

interface FieldErrorProps {
  error?: string
}

export const FieldError: FC<FieldErrorProps> = ({ error }) => {
  if (!error) return null
  return (
    <div className="form-input__error-messages-container bg-white border border-red mt-2 rounded h-7 flex flex-col justify-center">
      <small className={`${styles['form-input__error-message']}`}>{error}</small>
    </div>
  )
}
